export enum MAIN_ROUTES {
  ROOT = "/",
  CHAT_ID = "chatId",
  // USER PROFILE
  PROFILE = "profile",
}
